'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v11a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4zm4-2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M10.371 17.072a1 1 0 0 1 .557 1.3l-2 5a1 1 0 1 1-1.856-.743l2-5a1 1 0 0 1 1.3-.558M13.629 17.072a1 1 0 0 0-.557 1.3l2 5a1 1 0 0 0 1.857-.743l-2-5a1 1 0 0 0-1.3-.558" clipRule="evenodd" /><path fill="currentColor" d="M14.594 8.746c.541.32.541 1.187 0 1.508L10.12 12.9c-.508.3-1.12-.111-1.12-.754V6.854c0-.643.612-1.054 1.12-.754z" /></svg>;
const IconLearningVideo = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconLearningVideo;